import { useLayoutsQuery } from '../../generated/graphql';
import useConcession from '../../hooks/useConcession';
import { FilterProps } from '../../types/types';
import { SelectFilter } from '../SelectFilter/SelectFilter';

export default function LayoutFilter(props: FilterProps) {
    const { value, onChange, width = 150 } = props
    const query = useLayoutsQuery
    const concession = useConcession()

    return (
        <SelectFilter
            value={value}
            onChange={onChange}
            label="Esquema"
            query={query}
            field="layout"
            filter={{ concession: { id: { eq: concession?.id } } }}
            multiple={true}
            width={width}
            paging={{ limit: 999 }}
        />
    )
}
